import React, {useEffect, useMemo} from 'react';
import {Redirect, Switch} from 'react-router';
import AppRoute from './AppRoute';
import {getLocalData} from '../../../services/StorageServices';
import HomeContainer from '../../home/components/HomeContainer';
import NotFound from '../../404/components/NotFound';
import {Routers} from './RoutesConfig';
import {useRoles} from '../../hooks/useRoles';

function Dashboard({basePath, roles: propRoles}) {
    const roles = useRoles(propRoles);

    useEffect(() => {
        const logoTenant = getLocalData('logoTenant');
        if (!logoTenant) return;

        const favicon = logoTenant.find(item => item.layoutField === 'favicon');
        if (favicon) {
            const faviconElm = document.getElementById('favicon');
            if (faviconElm) {
                faviconElm.href = `/logo/${favicon.fieldTitle}`;
            }
        }
    }, []);

    const routes = useMemo(() => (
        Routers.map((item) => (
            <AppRoute
                key={item.path}
                path={`${basePath}${item.path}`}
                exact={item.exact}
                component={item.components}
                roles={roles}
            />
        ))
    ), [basePath, roles]);

    return (
        <Switch>
            <AppRoute
                path={basePath}
                roles={roles}
                exact
                component={HomeContainer}
            />
            {routes}
            <AppRoute path={`${basePath}/not-found`} exact component={NotFound}/>
            <Redirect to={`${basePath}/not-found`}/>
        </Switch>
    );
}

export default React.memo(Dashboard);